import { uid } from 'uid'
import { createHash } from './cart'

export default {
  async addToCart(product) {
    if (!window.gtag) return

    try {
      // Get user store and runtime config
      const userStore = useUserStore()
      const runtimeConfig = useRuntimeConfig()

      // Set Enhanced Conversions user data if available
      if (userStore?.email || userStore?.gclid) {
        const userData = {}

        if (userStore.email) {
          userData.email = userStore.email
          userData.sha256_email_address = await createHash(userStore.email)
        }

        // Add address data if available from userStore
        if (userStore.shippingAddress?.line1) {
          const address = userStore.shippingAddress
          userData.phone = address.phone
          userData.first_name = address.firstName
          userData.last_name = address.lastName
          userData.street = address.line1
          userData.city = address.city
          userData.region = address.stateCode
          userData.postal_code = address.zipCode
          userData.country = address.countryCode

          // Add hashed data for Enhanced Conversions
          userData.sha256_phone_number = await createHash(address.phone)
          userData.address = {
            sha256_first_name: await createHash(address.firstName),
            sha256_last_name: await createHash(address.lastName),
            street: address.line1,
            city: address.city,
            region: address.stateCode,
            postal_code: address.zipCode,
            country: address.countryCode,
          }
        }

        window.gtag('set', 'user_data', userData)
      }

      // Track AddToCart conversion
      const conversionLabel = runtimeConfig?.public?.googleAds?.conversionLabel || 'XFrwCO_omfYYEJu2icoD'
      const conversionId = runtimeConfig?.public?.googleAds?.conversionId || 'AW-960650011'

      window.gtag('event', 'conversion', {
        send_to: `${conversionId}/${conversionLabel}`,
        event_id: uid(32),
        currency: product.currency || 'GBP',
        value: product.value || product.price,
        transaction_id: product.transaction_id,
        items: [
          {
            item_id: product.sku || product.id,
            item_name: product.content_name || product.name,
            item_category: product.content_category || product.category,
            price: product.value || product.price,
            quantity: 1,
          },
        ],
      })

      // Also track as gtag AddToCart event for audience building
      window.gtag('event', 'add_to_cart', {
        event_id: uid(32),
        currency: product.currency || 'GBP',
        value: product.value || product.price,
        items: [
          {
            item_id: product.sku || product.id,
            item_name: product.content_name || product.name,
            item_category: product.content_category || product.category,
            price: product.value || product.price,
            quantity: 1,
          },
        ],
      })
    } catch (error) {
      console.error('[Google Ads] Add to cart tracking failed:', error)
    }
  },

  viewContent(product) {
    if (!window.gtag) return

    try {
      // Get user store
      const userStore = useUserStore()

      // Set Enhanced Conversions user data if available for remarketing
      if (userStore?.email) {
        window.gtag('set', 'user_data', {
          email: userStore.email,
        })
      }

      window.gtag('event', 'view_item', {
        event_id: uid(32),
        currency: product.currency || 'GBP',
        value: product.value || product.price,
        items: [
          {
            item_id: product.sku || product.id,
            item_name: product.content_name || product.name,
            item_category: product.content_category || product.category,
            price: product.value || product.price,
            quantity: 1,
          },
        ],
      })
    } catch (error) {
      console.error('[Google Ads] View content tracking failed:', error)
    }
  },

  pageVisit() {
    if (!window.gtag) return

    try {
      // Get user store
      const userStore = useUserStore()

      // Set Enhanced Conversions user data for page views
      if (userStore?.email) {
        window.gtag('set', 'user_data', {
          email: userStore.email,
        })
      }

      window.gtag('event', 'page_view', {
        event_id: uid(32),
      })
    } catch (error) {
      console.error('[Google Ads] Page view tracking failed:', error)
    }
  },

  // Generic conversion tracking for other events
  conversion(conversionLabel, conversionValue = null, currency = 'GBP') {
    if (!window.gtag) return

    try {
      // Get user store and runtime config
      const userStore = useUserStore()
      const runtimeConfig = useRuntimeConfig()

      // Set Enhanced Conversions user data if available
      if (userStore?.email) {
        window.gtag('set', 'user_data', {
          email: userStore.email,
        })
      }

      const conversionId = runtimeConfig?.public?.googleAds?.conversionId || 'AW-960650011'

      const conversionData = {
        send_to: `${conversionId}/${conversionLabel}`,
        event_id: uid(32),
      }

      if (conversionValue !== null) {
        conversionData.value = conversionValue
        conversionData.currency = currency
      }

      window.gtag('event', 'conversion', conversionData)
    } catch (error) {
      console.error('[Google Ads] Conversion tracking failed:', error)
    }
  },
}
